import React from 'react';
import { faSparkles, faSuitcase, faUser } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar, Button, Card, Tooltip } from 'antd';
import { isEmpty, last, slice, split } from 'lodash';
import { func, instanceOf } from 'prop-types';

import I18nCustomFormatter from 'Src/common/components/i18nCustomFormatter';
import ServicePill from '../../common/servicePill';

function MentorCard({ data, handleViewDetailsClick }) {
  const mentorServices = split(data.mentor_services, ',');
  const extraServices = slice(mentorServices, 2);

  return (
    <Card className="mentor-card">
      <div className="arc-d-flex card-content-wrapper">
        <div className="arc-d-flex arc-flex-space-between-align">
          <Avatar
            className="mentor-listing-avatar"
            shape="square"
            size={64}
            src={data.present_picture}
            icon={<FontAwesomeIcon icon={faUser} />} />
          <Button
            className="mentor-view-details-btn arc-color-primary"
            type="ghost"
            onClick={() => handleViewDetailsClick(data)}>
            <I18nCustomFormatter id="view-mentor-details" />
          </Button>
        </div>
        <div className="mt8">
          <Button type="link" size="small" className="user-name-btn" onClick={() => handleViewDetailsClick(data)}>
            <span className="arc-color-primary arc-H250">{data.full_name}</span>
          </Button>
        </div>
        <If condition={!isEmpty(data.employment)}>
          <div className="mt6">
            <FontAwesomeIcon icon={faSuitcase} className="mr4 employment-icon" />
            <span className="arc-p">
              <If condition={last(data.employment).designation}>
                {last(data.employment).designation}
                {' '}
                at
                {' '}
              </If>
              {last(data.employment).employer}
            </span>
          </div>
        </If>
        <div className="mentor-services-offered mt12 arc-d-flex arc-flex-vertical-align">
          <I18nCustomFormatter id="mentor-offering-services" />
          {slice(mentorServices, 0, 2).map((service, idx) => (
            <ServicePill name={service} key={idx} />
          ))}
          <If condition={!isEmpty(extraServices)}>
            <Tooltip title={extraServices.join(', ')}>
              <div>
                <ServicePill name={`+${extraServices.length}`} />
              </div>
            </Tooltip>
          </If>
        </div>
        <If condition={data.recommended}>
          <div className="mt12 arc-d-flex arc-flex-vertical-align">
            <div className="hex-bg">
              <FontAwesomeIcon icon={faSparkles} className="arc-color-primary mr2 arc-support" />
            </div>
            <span className="arc-color-gray8 arc-support ml4">
              <I18nCustomFormatter id="recommended-mentors" />
            </span>
          </div>
        </If>
      </div>
    </Card>
  );
}

MentorCard.propTypes = {
  data: instanceOf(Object).isRequired,
  handleViewDetailsClick: func.isRequired,
};

export default MentorCard;
